import * as React from 'react';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { FiltersDetails } from 'app/area/import-mappings/list-items/components/filters-details';
import { ImportMappingsTranslation } from 'app/area/import-mappings/constants';
import { CodetableMetadata, ImportMappingsOptions } from 'app/area/import-mappings/types-store';
import { LoadCodeItemsParams } from 'app/area/import-mappings/types';

interface ImportMappingsToolbarProps {
  metadata: CodetableMetadata;
  codetable: ComplexValue<number>;
  importSet: ComplexValue<number>;
  category: ComplexValue<number>;
  options: ImportMappingsOptions;
  shouldPrompt: boolean;
  translation: ImportMappingsTranslation;
  loadCodetableOptions: (
    id: string,
    codetableId: number,
    loadOptionsParams: LoadOptions,
    optionsParams?: LoadCodeItemsParams
  ) => void;
  updateCodetable: (value: ComplexValue<number>) => void;
  updateCategory: (value: ComplexValue<number>) => void;
  updateImportSet: (value: ComplexValue<number>) => void;
}

export const ImportMappingsToolbar: React.FC<ImportMappingsToolbarProps> = props => {
  const { metadata, codetable, importSet, category, shouldPrompt, translation,
    options, loadCodetableOptions, updateCodetable, updateCategory, updateImportSet } = props;

  return <>
    <div className="row">
      <h1 className="col-12">{translation.title}</h1>
    </div>

    <FiltersDetails
      metadata={metadata}
      codetable={codetable}
      importSet={importSet}
      category={category}
      options={options}
      loadCodetableOptions={loadCodetableOptions}
      updateCodetable={updateCodetable}
      updateCategory={updateCategory}
      updateImportSet={updateImportSet}
      shouldPrompt={shouldPrompt}
      translation={translation} />
  </>;
};
